<template>
  <div v-if="!isLoading" class="series-list-box">
    <ul class="series-list">
      <li
        v-for="(thumb, index) in seriesCellList"
        :key="`series_thumb_${index}`"
        class="item"
      >
        <ThumbSeries :thumb="thumb" />
      </li>
      <li v-if="isOdd" class="item" aria-hidden="true">&nbsp;</li>
    </ul>
  </div>
</template>

<script>
import _ from 'lodash'
import { getMovieSeriesContents } from '@/common/utils/request'
import ThumbSeries from '@/components/model/ThumbSeries'

export default {
  name: 'MovieSeriesContentList',
  components: {
    ThumbSeries
  },
  props: {
    contentInfo: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      seriesCellList: [],
      isLoading: true,
      isOdd: false
    }
  },
  created () {
    this.setData()
  },
  methods: {
    setData () {
      this.isLoading = true
      const movieId = _.get(this.contentInfo, 'movieid', '')
      getMovieSeriesContents({ movieid: movieId })
      .then(({ data }) => {
        this.seriesCellList = _.get(data, 'cell_toplist.celllist', [])
        this.isOdd = (this.seriesCellList.length % 2) === 1
        this.isLoading = false
      })
    }
  }
}
</script>
